import * as React from "react"
import Svg, { Path } from "react-native-svg"

function RightBlackArrow(props: any) {
    return (
        <Svg
            width={props?.size ? props.size: 24}
            height={props?.size ? props.size : 24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <Path
                d="M15.248 11.855c0 .1-.016.192-.05.275a.762.762 0 01-.175.25l-4.95 4.95c-.133.134-.312.196-.537.188a.769.769 0 01-.538-.213c-.167-.166-.237-.346-.212-.537a.94.94 0 01.237-.513l4.4-4.4-4.4-4.4a.816.816 0 01-.225-.537.592.592 0 01.225-.538.55.55 0 01.525-.212c.217.025.4.104.55.237l4.925 4.925a.764.764 0 01.175.25c.034.084.05.175.05.275z"
                fill="#1D2939"
            />
        </Svg>
    )
}

export default RightBlackArrow
